import React from 'react';
import Index from './src/pages/index.js';
import './src/styles/global.css'

export const wrapPageElement = ({ element, props }) => 
{
  return <Index {...props} />;
};